@if (!requestInProgress) {
  <div [@animateButtons]="animateButtons">
    @for (singleBtnGroup of quickResponseButtonSetInput; track singleBtnGroup) {
      <div class="text-center">
        <div class="row">
          @for (btn of singleBtnGroup.btnGroup; track btn) {
            <div class="col" [ngStyle]="{'min-width.px': btn.width}">
              <button role="button" class="quick-button btn btn-primary btn-block"
                name="{{ btn.btnText }}" type="button" (click)="onButtonClick(btn)">
                {{ btn.btnText }}
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
}